import { captureMessage } from '@sentry/browser';

export const withTimeout = <T>(
    operation: () => Promise<T>,
    timeoutMs: number,
): Promise<T> => {
    return new Promise<T>((resolve, reject) => {
        const timeoutId = setTimeout(() => {
            captureMessage('withTimeout: operation timeout', {
                level: 'warning',
                extra: {
                    timeoutMs,
                },
            });
            reject(new Error('Operation timeout'));
        }, timeoutMs);

        operation()
            .then((result) => {
                clearTimeout(timeoutId);
                resolve(result);
            })
            .catch((error) => {
                clearTimeout(timeoutId);
                reject(error);
            });
    });
};
